module.exports = __webpack_public_path__ + "img/therapi.d4fdee78.png";